import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { IBalanceSheetStatement } from "./BalanceSheetStatements.types";
import { getFileExtensionFromUrl } from "../../../helpers";

export const FETCH_BALANCE_SHEET_STATEMENTS_LIST_PROGRESS =
  "FETCH_BALANCE_SHEET_STATEMENTS_LIST_PROGRESS";
export const FETCH_BALANCE_SHEET_STATEMENTS_LIST_SUCCESS =
  "FETCH_BALANCE_SHEET_STATEMENTS_LIST_SUCCESS";
export const FETCH_BALANCE_SHEET_STATEMENTS_LIST_FAILED =
  "FETCH_BALANCE_SHEET_STATEMENTS_LIST_FAILED";

export const fetchBalanceSheetStatementListProgress = () =>
  action(FETCH_BALANCE_SHEET_STATEMENTS_LIST_PROGRESS);
export const fetchBalanceSheetStatementListSuccess = (
  data: IBalanceSheetStatement[],
  totalRecords: number
) =>
  action(FETCH_BALANCE_SHEET_STATEMENTS_LIST_SUCCESS, { data, totalRecords });
export const fetchBalanceSheetStatementListFailed = () =>
  action(FETCH_BALANCE_SHEET_STATEMENTS_LIST_FAILED);

export const fetchBalanceSheetStatementListAsync =
  (
    status: string,
    date: IDataTableV2DateState["dates"],
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date } = searchState;
      dispatch(fetchBalanceSheetStatementListProgress());
      // let finalUrl = `/accounting/get-balance-sheet-data?from_date=${from_date}&to_date=${to_date}`;
      let finalUrl = `/accounting/get-balance-sheet-data-v2?from_date=${from_date}&to_date=${to_date}`;


      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      const res = await api.get(finalUrl);
      const data: IBalanceSheetStatement[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchBalanceSheetStatementListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchBalanceSheetStatementListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchBalanceSheetStatementListForExportAsync =
  (
    date: IDataTableV2DateState["dates"],
    versionV2: boolean,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { fromDate, toDate } = date;
      dispatch(saveLoaderProgress());

      const finalUrl = `/accounting/get-balance-sheet-data-v2-pdf?from_date=${fromDate}&to_date=${toDate}`;

      // if (from_date) {
      //   const filterObj = {
      //     column: ["date"],
      //     operator: "GREATER_THAN_EQUAL",
      //     value: from_date,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }
      // if (to_date) {
      //   const filterObj = {
      //     column: ["date"],
      //     operator: "LESSER_THAN_EQUAL",
      //     value: to_date,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }

      const res = await api.get(finalUrl, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([res.data], {
        type: "application/" + getFileExtensionFromUrl("Balance_sheet.pdf"),
      });
      // const blob = new Blob([res.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      // Create a link element and simulate a click to trigger the download
      const link = document.createElement("a");
      link.href = url;
     link.setAttribute("download", "Balance_sheet.pdf");// Set the desired file name and extension
      document.body.appendChild(link);
      link.click();

      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_BALANCE_SHEET_STATEMENTS = "CLEAR_BALANCE_SHEET_STATEMENTS";
export const clearBalanceSheetStatements = () =>
  action(CLEAR_BALANCE_SHEET_STATEMENTS);
